import React from 'react';
import PropTypes from 'prop-types';
import Banner from './Banner';

const REGISTER_HEADER = 'Register to Vote';

const BANNER_CONTENT = [
    {
        preLinkText: 'National Voter Registration Day is September 22. ',
        linkText: 'Register to vote.',
        postLinkText: '',
    },
    {
        preLinkText: '',
        linkText: 'Register to vote or check your voter status',
        postLinkText: ' for the 2020 US Election.',
    },
];

const RegisterToVoteBanner = (props) => {
    const trackingData = {
        type: 'TRACK_REGISTER_TO_VOTE_BANNER_CLICK',
        meta: {
            analytics: {
                action: 'VoteBannerClick',
                category: props.category,
            },
        },
    };

    const { preLinkText, linkText, postLinkText } = BANNER_CONTENT[
        props.version
    ];

    return (
        <Banner leftAccentColor="#F05537" style="dark" header={REGISTER_HEADER}>
            <span>
                {preLinkText}
                <a
                    onClick={() => {
                        props.handleTracking(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://www.headcount.org/eventbrite/?${props.trackingParams}`}
                >
                    {linkText}
                </a>
                {postLinkText}
            </span>
        </Banner>
    );
};

RegisterToVoteBanner.propTypes = {
    handleTracking: PropTypes.func,
    category: PropTypes.string,
    trackingParams: PropTypes.string,
    version: PropTypes.number,
};

export default RegisterToVoteBanner;
